<app-stack-layout>
    <h1>Dataedo Downloads</h1>

    <div class="mt-lg">
        <div class="downloads-list">
            <table *ngIf="dataedoDownloads$ | async as downloads">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Version</th>
                    <th>Filename</th>
                    <th>Type</th>
                    <th>Bit</th>
                    <th>File Size (bytes)</th>
                    <th>Download</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let release of downloads.dataedoDownloads">
                    <td>{{ release.name }}</td>
                    <td>{{ release.major }}.{{ release.minor }}.{{ release.build }}</td>
                    <td>{{ release.filename }}</td>
                    <td>{{ release.type }}</td>
                    <td>{{ release.bit }}</td>
                    <td>
                        {{ release.file_size === 0 || release.file_size === null ? 'N/A' : (release.file_size / 1024 / 1024) | number:'1.2-2' }}
                        {{ release.file_size !== 0 && release.file_size !== null ? 'MB' : '' }}
                    </td>
                    <td>
                        <a *ngIf="release.file_size !== 0 && release.file_size !== null"
                           href="https://dataedo.com/download/datedo/{{encodeFileName(release.filename)}}"
                           download
                        > Download </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-stack-layout>
